import { render, staticRenderFns } from "./StockStores.vue?vue&type=template&id=437fb708&scoped=true&"
import script from "./StockStores.vue?vue&type=script&lang=js&"
export * from "./StockStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437fb708",
  null
  
)

export default component.exports